import React, { useRef, useEffect, useContext } from 'react';
import { ScrollView } from 'react-native';
import type { BoundScrollViewProps } from './BoundScrollView.types';
import { BoundScrollContext } from './BoundScrollView.context';

export const BoundScrollView = (
  props: BoundScrollViewProps,
): React.ReactElement => {
  const { children, ...rest } = props;
  const { addScrollReference, clearScrollReference, onScroll } =
    useContext(BoundScrollContext);
  const scrollReference = useRef(null);

  useEffect(() => {
    addScrollReference(scrollReference);

    return () => {
      clearScrollReference();
    };
  }, [scrollReference, addScrollReference, clearScrollReference]);

  return (
    <ScrollView
      {...rest}
      ref={scrollReference}
      onScroll={onScroll}
      scrollEventThrottle={16}
    >
      {children}
    </ScrollView>
  );
};
